<pmd-input-group-outline pmd-input-group-icon class="language-dropdown">
  <pmd-input-group-prepend>
    <i class="material-icons md-dark pmd-icon-sm">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        aria-hidden="true"
      >
        <path
          id="Path_34"
          data-name="Path 34"
          d="M9.5,2A7.5,7.5,0,1,0,17,9.5,7.5,7.5,0,0,0,9.5,2ZM8.75,15.448A5.991,5.991,0,0,1,3.5,9.5a6.088,6.088,0,0,1,.158-1.343L7.25,11.75v.75A1.5,1.5,0,0,0,8.75,14Zm5.175-1.905A1.488,1.488,0,0,0,12.5,12.5h-.75V10.25A.752.752,0,0,0,11,9.5H6.5V8H8a.752.752,0,0,0,.75-.75V5.75h1.5a1.5,1.5,0,0,0,1.5-1.5V3.942a5.987,5.987,0,0,1,2.175,9.6Z"
          transform="translate(-2 -2)"
          fill="#843e06"
        />
      </svg>
    </i>
  </pmd-input-group-prepend>
  <ng-select
    [placeholder]="'LAYOUT.HOME.LANGUAGE_PLACEHOLDER' | translate"
    [ariaLabel]="'LAYOUT.HOME.LANGUAGE_PLACEHOLDER' | translate"
    appearance="outline"
    [searchable]="false"
    pmdTextField
    [clearable]="false"
    labelForId="languageId"
    name="language"
    [items]="languagesSubject | async"
    bindLabel="name"
    bindValue="code"
    [(ngModel)]="currentLanguage"
    (change)="changeLang()"
    class="pmd-select pmd-select-outline pmd-select-sm"
    tabIndex="-1"
  >
  </ng-select>
</pmd-input-group-outline>
